import { InfoRow } from '@/components/InfoRow';
import { Section, SectionGroup } from '@/components/Section';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { config } from '@/lib/config';
import { useAuthStore } from '@/lib/store/auth';
import { RELEASED, VERSION_LABEL } from '@/lib/version';

export function AccountPrefsModal({
  open,
  onOpenChange,
}: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[88dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Account Settings</DialogTitle>
          <div className="text-[0.692em] text-(--color-text3) font-mono">
            {config.tenant.label} · {user.email}
          </div>
        </DialogHeader>
        <SectionGroup>
          <Section title="Personal Info">
            <div className="rounded-md border border-(--color-border) bg-(--color-bg) px-3 py-2">
              <InfoRow label="Full Name" value={user.fullName} />
              <InfoRow label="Status" value={<Badge variant="ok">ACTIVE</Badge>} />
              <InfoRow label="Email" value={user.email} mono />
              <InfoRow label="Language" value="en" mono />
              <InfoRow label="Phone" value="+1 780 555 0198" mono />
              <InfoRow label="Timezone" value="America/Edmonton" mono />
              <InfoRow label="Country" value="CA" mono />
              <InfoRow label="Company Admin" value={user.isAdmin ? 'Yes' : 'No'} />
            </div>
          </Section>
          <Section title="Roles">
            <div className="flex flex-wrap gap-1">
              {user.roles.map((r) => (
                <Badge key={r} variant="muted">
                  {r}
                </Badge>
              ))}
            </div>
          </Section>
          <Section title="Certification">
            <div className="rounded-md border border-(--color-border) bg-(--color-bg) px-3 py-2">
              <InfoRow label="Legal Profile" value="Transport Canada" />
              <InfoRow label="License Type" value="Advanced" />
              <InfoRow label="License Number" value="TC-ADV-12345" mono />
            </div>
          </Section>
          <Section title="Metadata">
            <div className="rounded-md border border-(--color-border) bg-(--color-bg) px-3 py-2">
              <InfoRow label="Tenant" value={config.tenant.label} />
              <InfoRow label="User ID" value={user.id} mono />
            </div>
          </Section>
          <Section title="About">
            <div className="rounded-md border border-(--color-border) bg-(--color-bg) px-3 py-2">
              <InfoRow label="Version" value={VERSION_LABEL} mono />
              <InfoRow label="Released" value={RELEASED} mono />
              <InfoRow label="Data Source" value={config.dataSource === 'live' ? 'Live' : 'Demo'} />
              <InfoRow label="MQTT Schema" value={config.mqtt.schema} mono />
            </div>
          </Section>
        </SectionGroup>
      </DialogContent>
    </Dialog>
  );
}
